import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import { Observable } from 'rxjs';
import {AutorizacaoService} from "../services/autorizacao.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGrupoGuard implements CanActivate {
  constructor(private router: Router, private autorizacaoService: AutorizacaoService) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.autorizacaoService.estaLogado().then((resposta: any) => {

      if (!resposta.logado) {
        this.router.navigate(['/admin-grupo/login'], {queryParams: {t: state.url}}).then(() => {
        });
        return false;
      }

      console.log('AuthGuard')
      console.log(resposta)

      return true;
    });
  }
}
